// Beat volume — touch slider above the transport (0–150 %). Live, saved on release.
import React from "react";
import { X } from "lucide-react";
import { Slider } from "../ui/slider";

export function BeatVolumeSlider({ value, onChange, onCommit, onClose }) {
  const pct = Math.round(value * 100);
  return (
    <div className="absolute bottom-full inset-x-0 bg-[#0f0b1a] border-t border-fuchsia-500/30 px-4 py-3" data-testid="beat-volume-panel">
      <div className="max-w-2xl mx-auto flex items-center gap-3">
        <span className="text-[10px] uppercase tracking-widest font-bold text-fuchsia-300 whitespace-nowrap">Beat</span>
        <Slider min={0} max={150} step={1} value={[pct]} aria-label="Beat volume"
          onValueChange={([v]) => onChange(v / 100)} onValueCommit={([v]) => onCommit(v / 100)}
          className="flex-1 py-3 [&_[role=slider]]:h-6 [&_[role=slider]]:w-6 [&_[role=slider]]:bg-white [&_[role=slider]]:border-fuchsia-400 [&>span:first-child]:h-2 [&>span:first-child]:bg-white/10 [&>span:first-child>span]:bg-fuchsia-500"
          data-testid="beat-volume-slider" />
        <span className="text-xs font-bold tabular-nums w-11 text-right" data-testid="beat-volume-value">{pct}%</span>
        <button type="button" onClick={onClose} className="text-gray-400 p-1" aria-label="Close beat volume" data-testid="beat-volume-close-btn"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
